// RichTextField.jsx
import { useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Box, Typography } from "@mui/material";
import { formatTitle } from "../utils";
import { ColorsConstants } from "../../../../cssUtils/constants";

// Toolbar is restricted to formatting WhatsApp free-form messages can actually render.
const WHATSAPP_SAFE_MODULES = {
  toolbar: [
    ["bold", "italic", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
  ],
};

const WHATSAPP_SAFE_FORMATS = ["bold", "italic", "strike", "list", "bullet"];

export const RichTextField = ({
  fieldKey,
  schema,
  value,
  required,
  onChange,
}) => {
  const modules = useMemo(() => WHATSAPP_SAFE_MODULES, []);

  return (
    <Box>
      <Typography sx={{ fontWeight: 600, mb: 0.5 }}>
        {formatTitle(fieldKey)}
        {required && (
          <Typography component="span" sx={{ color: ColorsConstants.error }}>
            {" "}
            *
          </Typography>
        )}
      </Typography>
      <Box sx={{ "& .ql-editor": { minHeight: "100px" } }}>
        <ReactQuill
          theme="snow"
          value={value || ""}
          onChange={(content, delta, source) => {
            // Quill fires onChange with source "api"/"silent" when it
            // normalizes the initial HTML on mount (e.g. empty string ->
            // "<p><br></p>") — only forward genuine user edits, or selecting
            // the node flags it dirty without anything actually changing.
            if (source === "user") onChange(content);
          }}
          modules={modules}
          formats={WHATSAPP_SAFE_FORMATS}
          placeholder={schema?.description}
        />
      </Box>
    </Box>
  );
};
